import React from 'react';
import { Offcanvas } from 'react-bootstrap';

/**
 * Reusable Help Pane Component
 * Displays help content in a right-side vertical pane
 * 
 * @param {boolean} show - Whether to show the help pane
 * @param {function} onHide - Callback to close the help pane
 * @param {string} title - Title of the help content
 * @param {React.ReactNode} children - Help content to display
 */
function HelpPane({ show, onHide, title, children }) {
  return (
    <Offcanvas 
      show={show} 
      onHide={onHide} 
      placement="end" 
      style={{ width: '400px' }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Help: {title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="help-content">
          {children}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default HelpPane;

